module.exports = __webpack_public_path__ + "media/images/countrysquared/tj-9844647bbf6e91cc68efb1b9f07ced42.svg";